<template>
	<div class="qingwu">
		<el-form label-width="100px" ref="info" :rules="rules" :model="info">
			<el-form-item label="微信appid" prop="wechat_appid">
				<el-input type="text" placeholder="请输入微信appid" v-model="info.wechat_appid"></el-input>
			</el-form-item>
			<el-form-item label="商户号" prop="wechat_mid">
				<el-input type="text" placeholder="请输入商户号" v-model="info.wechat_mid"></el-input>
			</el-form-item>
			<el-form-item label="商户秘钥" prop="wechat_key">
				<el-input type="textarea" :rows="5" placeholder="请输入商户秘钥" v-model="info.wechat_key"></el-input>
			</el-form-item>
			<el-form-item label="key证书" prop="wechat_apiclient_key">
				<el-input type="textarea" :rows="5" placeholder="请输入key证书" v-model="info.wechat_apiclient_key"></el-input>
			</el-form-item>
			<el-form-item label="cert证书" prop="wechat_apiclient_cert">
				<el-input type="textarea" :rows="5" placeholder="请输入cert证书" v-model="info.wechat_apiclient_cert"></el-input>
			</el-form-item>
			<el-form-item label-width="160px">
				<el-button type="primary" @click="submitForm('info')">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				info: {},
				rules: {
					wechat_appid: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					wechat_mid: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					wechat_key: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					wechat_apiclient_key: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					wechat_apiclient_cert: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}]
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			submitForm: function(e) {
				this.$refs[e].validate(res => {
					if (res) {
						// Http 请求
						this.$post(this.$api.wechatpayConfig, this.info).then(postRes => {
							if (postRes.code == 200) {
								this.$message.success("编辑成功");
								this.get_config();
							} else {
								this.$message.error("编辑失败");
							}
						});
					}
				});
			},
			get_config() {
				this.$get(this.$api.wechatpayConfig).then(res => {
					if (res.data != null) {
						this.info = res.data;
					}
				});
			},
		},
		created() {
			this.get_config();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>

</style>